module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"page-subtitle":{"prefix":"til"}},"de":{"version":1,"page-subtitle":{"prefix":"für"}},"en":{"page-subtitle":{"prefix":"for"}},"fr":{"page-subtitle":{"prefix":"pour"}},"nl":{"page-subtitle":{"prefix":"voor"}},"pl":{"page-subtitle":{"prefix":"do"}}}')
  delete Component.options._Ctor
}
